import { render, staticRenderFns } from "./CartaoAssociado.vue?vue&type=template&id=4e8c29a7&"
import script from "./CartaoAssociado.vue?vue&type=script&lang=js&"
export * from "./CartaoAssociado.vue?vue&type=script&lang=js&"
import style0 from "./CartaoAssociado.vue?vue&type=style&index=0&id=4e8c29a7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports